export class TypedEventTarget<TEventMap extends Record<string, Event>> extends EventTarget {
  dispatchEvent<T extends Extract<keyof TEventMap, string>>(event: TEventMap[T]): boolean {
    return super.dispatchEvent(event);
  }

  protected addTypedListener<T extends keyof TEventMap>(
    type: T,
    handler: (e: TEventMap[T]) => void,
    options?: boolean | AddEventListenerOptions
  ): void {
    this.addEventListener(type as string, handler as EventListener, options);
  }
}
